"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DASHBOARD_AGENT_STARTING_MODE_IDS = void 0;
exports.isDashboardAgentStartingModeId = isDashboardAgentStartingModeId;
/**
 * Starting modes a regular organization member may explicitly request when
 * launching an agent from the dashboard selector.
 */
exports.DASHBOARD_AGENT_STARTING_MODE_IDS = [
    'router',
    'static',
    'video',
    'media-buying',
    'media-buyer-meta',
    'media-buyer-google',
    'media-buyer-tiktok',
    'organic-posting',
    'brand-intelligence',
    'meta-ads-researcher',
];
const DASHBOARD_AGENT_STARTING_MODE_ID_SET = new Set(exports.DASHBOARD_AGENT_STARTING_MODE_IDS);
/** Returns whether a mode can be selected by a regular member from the dashboard. */
function isDashboardAgentStartingModeId(value) {
    return DASHBOARD_AGENT_STARTING_MODE_ID_SET.has(value);
}
